import CardWithFields from "components/General/CardWithFields";
import CardDisclaimerBase from "components/General/CardDisclaimerBase/CardDisclaimerBase";

import { stringFormattingToCurrency, getPaymentMode } from "js/formatting";
import { useTranslation, Trans } from "react-i18next";

export default function PaymentDetails({ paymentStream }) {
  const { t } = useTranslation();
  return (
    <CardWithFields
      additionalContent={
        <CardDisclaimerBase
          disclaimer={
            <>
              <Trans
                i18nKey="CustomerPolicyDetails-annuity-Payment-Details-disclaimer"
                components={{ break: <br /> }}
              />
            </>
          }
        />
      }
      ariaLabel={t("CustomerPolicyDetails-annuity-Payment-Details-card-title")}
      cardTitle={t("CustomerPolicyDetails-annuity-Payment-Details-card-title")}
      cardFields={[
        {
          title: t(
            "CustomerPolicyDetails-annuity-Payment-Details-payment-amount"
          ),
          value: paymentStream.map((stream, idx) => (
            <p key={`payment detail amount - ${idx + 1}`}>
              {stringFormattingToCurrency(parseFloat(stream.paymentAmount))}
            </p>
          )),
        },
        { title: "", value: <></> },
        {
          title: t(
            "CustomerPolicyDetails-annuity-Payment-Details-payment-mode"
          ),
          value: paymentStream.map((stream, idx) => (
            <p key={`payment detail mode - ${idx + 1}`}>
              {getPaymentMode(stream.paymentMethod)}
            </p>
          )),
        },
      ]}
    />
  );
}
